import { IS_HOMOLOGATION } from 'utils/constants';

const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1', '::1', '[::1]'];

/** Na máquina do dev o ambiente já é óbvio, então a faixa só atrapalha. */
const isLocalhost = () => LOCAL_HOSTNAMES.includes(window.location.hostname);

/**
 * Faixa fixa no topo que identifica o ambiente de homologação.
 *
 * O z-index fica acima de tudo que existe na aplicação (maior valor atual: 10000)
 * e das bibliotecas de terceiros (modais em `#modal` e toasts usam 9999), e a faixa
 * não intercepta cliques para não bloquear a interface que fica embaixo dela.
 *
 * O brilho é um degradê recortado nas letras (`bg-clip-text`): a onda clara varre o
 * texto e descansa fora dele. Sem a animação o degradê fica parado na faixa escura,
 * então o texto continua preto e legível.
 */
const EnvironmentBanner = () => {
  if (!IS_HOMOLOGATION || isLocalhost()) return null;

  return (
    <div
      role="status"
      className="pointer-events-none fixed inset-x-0 top-0 z-[99999] select-none bg-yellow/90 pb-1.5 pt-[calc(env(safe-area-inset-top)_+_0.375rem)] text-center shadow-[0_0_18px_rgba(251,253,0,0.45)]"
    >
      <span className="animate-text-shine bg-[linear-gradient(100deg,#000_45%,rgba(0,0,0,0.2)_50%,#000_55%)] bg-[length:250%_100%] bg-clip-text text-xs/5 font-bold tracking-[0.2em] text-transparent motion-reduce:animate-none sm:text-sm/5">
        AMBIENTE DE HOMOLOGAÇÃO
      </span>
    </div>
  );
};

export default EnvironmentBanner;
